import React, { useEffect, useState } from 'react'
import ToastMessage from '../../../../common/ToastMessage';
import CustomDataGrid from '../../../../common/CustomDataGrid';
import usePurchaseOrderTypes from '../../../../store/ReactQueries/procurements/purchaseOrderTypes/usePurchaseOrderTypes';
import useAddPurchaseOrderType from '../../../../store/ReactQueries/procurements/purchaseOrderTypes/useAddPurchaseOrderType';
import useUpdatePurchaseOrderType from '../../../../store/ReactQueries/procurements/purchaseOrderTypes/useUpdatePurchaseOrderType';
import useDeletePurchaseOrderType from '../../../../store/ReactQueries/procurements/purchaseOrderTypes/useDeletePurchaseOrderType';
import { GridColDef } from '@mui/x-data-grid';
import { PAGESIZE } from '../../../../utils/constants';
import { FieldErrors } from '../../../../domain/helpers/Errors';
import { validateSchema } from '../../../../common/ValidateSchema';
import { useLanguageStore } from '../../../../store/useLanguageStore';
import { purchaseOrderTypeSchema } from '../../../../domain/ValidationSchemas/PurchaseOrder/purchaseOrderType';
import { PurchaseOrderTypeInterface } from '../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType';

export const PurchaseOrderTypes = () => {
    const { language } = useLanguageStore();

    const [page, setPage] = useState<number>(1);
    const [pageSize, setPageSize] = useState<number>(PAGESIZE);
    const [errors, setErrors] = useState<FieldErrors>({});
    const [form, setForm] = useState<PurchaseOrderTypeInterface>({
        id: '',
        title: '',
    });

    const [modal, setModal] = useState<{ add: boolean, edit: boolean, view: boolean }>({
        add: false,
        edit: false,
        view: false
    });

    let { data: purchaseOrderTypes, error: purchaseOrderTypeError, isLoading } = usePurchaseOrderTypes(page, pageSize);

    const addPurchaseOrderType = useAddPurchaseOrderType(page, pageSize);
    const updatePurchaseOrderType = useUpdatePurchaseOrderType(page, pageSize);
    const deletePurchaseOrderType = useDeletePurchaseOrderType(page, pageSize);


    useEffect(() => {
        if (purchaseOrderTypeError) ToastMessage.Failed(`Error: ${purchaseOrderTypeError.message}`);
    }, [purchaseOrderTypeError])

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'Id', type: "string", editable: false, width: 150 },
        { field: 'title', headerName: 'Title', type: "string", editable: false, width: 250 },

    ];

    const addItems = () => {
        setForm({
            ...form,
            id: '',
            title: ''
        });
        setModal({ ...modal, add: true });
        setErrors({});
    }

    const handleError = (error: unknown) => {
        if (error instanceof Error) ToastMessage.Failed(error.message);
        else ToastMessage.Failed();
    };

    const handleSave = async () => {
        const isValid = validateSchema(purchaseOrderTypeSchema, form);

        setErrors(isValid.errors);
        if (!isValid.result) return;

        const { id, title } = form;

        const upForm: PurchaseOrderTypeInterface = {
            id,
            title
        };

        if (upForm.id === '') {
            const { id, ...formData } = upForm;
            addPurchaseOrderType.mutate(formData, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        } else {
            updatePurchaseOrderType.mutate(upForm, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
        setModal({ ...modal, add: false, edit: false, view: false });
    }

    const handleDelete = async (id: string) => {
        if (await ToastMessage.Confirm(language['ToastDeleteItem'])) {
            deletePurchaseOrderType.mutate(id, {
                onSuccess: () => ToastMessage.Success(),
                onError: (error) => handleError(error),
            });
        }
    };

    return (
        <CustomDataGrid
            name={language['PurchaseOrderType']}
            rows={purchaseOrderTypes || []}
            form={form}
            page={page}
            modal={modal}
            errors={errors}
            columns={columns}
            loading={isLoading}
            pageSize={pageSize}
            setForm={setForm}
            setPage={setPage}
            setModal={setModal}
            addItems={addItems}
            setErrors={setErrors}
            handleSave={handleSave}
            setPageSize={setPageSize}
            handleDelete={handleDelete}
            hideColumns={['id']}
            showColumnModal={['title']}
        />
    );
}
export default PurchaseOrderTypes;